import {FC, memo} from 'react';

import css from '../styles/PartnersListItem.module.css';

interface PartnersListItemProps {
  src: string;
}
const PartnersListItem: FC<PartnersListItemProps> = ({src}) => {
  return (
    <div className={css.imageWrapper}>
      <img className={css.image} src={src} loading="lazy" alt="" />
    </div>
  );
};

export default memo(PartnersListItem);
